import { Link } from "react-router-dom";

const CTAButtons = ({ demoLink, signupLink }) => {
  return (
    <div className="d-flex  gap--15 mt--15">
      <Link
        to={demoLink || "/demo"}
        className="btn bg--transparent text--orange border--2 border--orange sf--t-medium radius--16-0"
      >
        Get your Demo
      </Link>
      <Link
        to={signupLink || "/signup"}
        className="btn bg--orange text--white border--2 border--orange sf--t-medium radius--16-0"
      >
        Try for free
      </Link>
    </div>
  );
};

export default CTAButtons;
